export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'Affinché la tua tecnologia di telecamere funzioni in modo affidabile nel tempo',
      lead: 'SSG Care è il nostro abbonamento di manutenzione e assistenza. Dopo l’installazione puoi far gestire il tuo impianto con un contratto Care flessibile, con canone mensile e durata concordata.',
    },
    abo: {
      title: 'Modello in abbonamento con durata flessibile',
      lead: 'L’installazione è fatturata una volta. L’assistenza continua avviene con abbonamento mensile, disdibile o con durata minima concordata.',
      items: {
        '0': { title: 'Assistenza mensile', desc: 'Scegli tra disdetta mensile o durata fissa (es. 12 o 24 mesi) con le relative condizioni.' },
        '1': { title: 'Ambito individuale', desc: 'Non ogni impianto ha bisogno di tutto. Definiamo insieme quali servizi rientrano nel contratto Care – scalabile e adattabile.' },
        '2': { title: 'Nessun costo nascosto', desc: 'Canone mensile trasparente. I servizi extra fuori contratto sono concordati e fatturati a parte.' },
      },
    },
    pricing: {
      eyebrow: 'Tariffe',
      title: 'Scegli la tua tariffa Care',
      lead: 'Tutti i prezzi sono indicativi. Il canone finale dipende da dimensioni, ambito e durata.',
      featured: 'Scelta più popolare',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'Per piccoli impianti', price: 'da 19 €/mese', features: { '0': 'Controllo trimestrale (remoto)', '1': 'Gestione aggiornamenti firmware', '2': 'Supporto app per telefono/email', '3': 'Richieste prioritarie' } },
        '1': { name: 'Care Professional', subtitle: 'Per impianti commerciali', price: 'da 39 €/mese', features: { '0': 'Controllo mensile (remoto)', '1': 'Aggiornamenti firmware e patch di sicurezza', '2': 'Gestione utenti e diritti', '3': 'Controllo archiviazione e registrazione', '4': 'Aiuto nel cambio di smartphone', '5': 'Servizio in loco su accordo', '6': 'Gestione prioritaria' } },
        '2': { name: 'Care Enterprise', subtitle: 'Per multi-sito e grandi progetti', price: 'Individuale', features: { '0': 'Controllo settimanale (remoto)', '1': 'Tutti i servizi Professional', '2': 'Referente dedicato', '3': 'Consigli di ampliamento proattivi', '4': 'Appuntamenti in loco regolari', '5': 'Documentazione e report' } },
      },
    },
    services: {
      title: 'Cosa può fare SSG Care per te',
      items: {
        '0': { title: 'Controlli periodici', desc: 'Controllo di funzione, registrazione e rete, remoto o in loco a seconda del piano.' },
        '1': { title: 'Aggiornamenti firmware', desc: 'Verifica ed esecuzione degli aggiornamenti concordati secondo il produttore.' },
        '2': { title: 'Supporto app e accesso', desc: 'Aiuto con problemi di app, accessi e cambio di smartphone o reinstallazione.' },
        '3': { title: 'Gestione utenti e diritti', desc: 'Gestione di accessi, nuovi utenti e modifiche dei permessi.' },
        '4': { title: 'Registrazione e archiviazione', desc: 'Controllo di occupazione, qualità di registrazione e backup.' },
        '5': { title: 'Supporto remoto', desc: 'Accesso remoto per diagnosi e configurazione, se possibile e desiderato.' },
      },
    },
    form: {
      title: 'La tua offerta Care personale',
      lead: 'Dicci quale assistenza hai in mente. Ti risponderemo con una proposta individuale con durata e canone.',
      customerType: 'Tipo di cliente',
      select: 'Seleziona',
      privat: 'Privato',
      gewerbe: 'Aziendale',
      locations: 'Numero di sedi',
      locations1: '1 sede',
      locations2: '2–3 sedi',
      locations3: '4 e più',
      cameraCount: 'Numero approssimativo di telecamere',
      cameras1: '1–2 telecamere',
      cameras2: '3–6 telecamere',
      cameras3: '7–12 telecamere',
      cameras4: '13 e più',
      systemStatus: 'Stato impianto',
      statusNew: 'Nuovo impianto',
      statusExisting: 'Impianto esistente',
      statusExtension: 'Ampliamento previsto',
      contractTerm: 'Durata contrattuale desiderata',
      termOpen: 'Aperto / da concordare',
      termMonthly: 'Disdetta mensile',
      term12: '12 mesi',
      term24: '24 mesi',
      term36: '36 mesi',
      name: 'Nome *',
      email: 'Email *',
      phone: 'Telefono',
      company: 'Azienda',
      message: 'Informazioni aggiuntive',
      maxChars: 'Massimo 500 caratteri',
      consent: 'Ho letto l’informativa privacy e acconsento al trattamento dei miei dati per questa richiesta. *',
      success: 'Grazie per la tua richiesta. Ti risponderemo presto con la tua offerta Care individuale.',
      submit: 'Invia richiesta Care',
      submitting: 'Invio...',
    },
  },
};